var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videos"},[_c('card-grid',{attrs:{"data":_vm.data,"type":"video"},on:{"on-delete-click":_vm.handleOnDeleteChange,"on-preview-click":_vm.handleOnPreviewChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }